// extracted by mini-css-extract-plugin
module.exports = {"date":"DateRangePeriod_date__NsjCd","over":"DateRangePeriod_over__nM2E-"};